module.exports = __webpack_public_path__ + "img/workflow-automation.f9f185c4.svg";